export class HelpersService {
  afterBrowserRedraw = (callback: () => void) => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        callback();
      });
    });
  };
}

export default new HelpersService();
